import { useEffect } from 'react';

// A simple custom hook to execute a function once (essentially the same as componentDidMount)
function useMount(effect) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
}
export default useMount;